import React from "react";

export default function Terms() {
  return (
    <div style={{ padding: "34px 18px 56px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <h1 style={{ marginTop: 0 }}>Terms of Service</h1>
        <div style={{ opacity: 0.75, marginBottom: 18 }}>Last updated: January 2026</div>

        <p>
          These Terms of Service govern your access to and use of the Splitley application. By accessing or using Splitley, you agree to these Terms. If you do not agree, please do not use the app.
        </p>

        <h2>Eligibility</h2>
        <p>You may use Splitley only if:</p>
        <ul>
          <li>You are at least 13 years old</li>
          <li>You are legally permitted to use the service under applicable laws</li>
          <li>You have not been previously suspended or banned from using Splitley</li>
        </ul>
        <p>
          By using the app, you confirm that you meet these requirements.
        </p>

        <h2>Description of the Service</h2>
        <p>
          Splitley is an expense splitting and tracking application designed to help users record and manage shared expenses, informal debts, and settlements with friends or groups.
        </p>
        <p>
          All expenses, balances, and records in Splitley are informal and non-binding. Splitley does not provide financial, legal, or accounting advice and does not guarantee the accuracy of user-entered data.
        </p>

        <h2>Informal Records Disclaimer</h2>
        <p>You acknowledge and agree that:</p>
        <ul>
          <li>Expenses and balances recorded in Splitley are informal records only</li>
          <li>They do not represent legally enforceable debts or obligations</li>
          <li>Splitley does not verify or validate the accuracy of expenses entered by users</li>
          <li>Any disputes between users must be resolved directly between those users</li>
        </ul>
        <p>
          Splitley is not responsible for disagreements, misunderstandings, or financial outcomes resulting from shared expenses.
        </p>

        <h2>User Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate and truthful information</li>
          <li>Use Splitley only for lawful and intended purposes</li>
          <li>Respect other users when sharing expenses and content</li>
          <li>Not misuse, disrupt, reverse engineer, or attempt to compromise the service</li>
        </ul>
        <p>
          You may not use Splitley for fraudulent activity, harassment, money laundering, or any illegal purpose.
        </p>

        <h2>Account Security</h2>
        <p>
          You are responsible for maintaining the security of your account and any access granted through Google Sign-In.
        </p>
        <p>
          Splitley is not responsible for unauthorized access resulting from your failure to protect your account, devices, or login credentials.
        </p>

        <h2>User Content and Data</h2>
        <p>
          When using Splitley, you may submit content such as expense descriptions, group names, comments, and related information.
        </p>
        <ul>
          <li>You retain ownership of your content</li>
          <li>You grant Splitley a limited license to store, process, and display this content solely to operate and provide the service</li>
          <li>You are solely responsible for the content you submit</li>
        </ul>
        <p>
          Splitley may remove content that violates these Terms or is otherwise harmful, unlawful, or inappropriate.
        </p>

        <h2>Acceptable Content Standards</h2>
        <p>You may not post or share content that:</p>
        <ul>
          <li>You do not have the right to share</li>
          <li>Is misleading, deceptive, or impersonates another person</li>
          <li>Is abusive, harassing, hateful, obscene, or threatening</li>
          <li>Violates privacy, intellectual property, or applicable laws</li>
          <li>Contains malware, spam, or malicious code</li>
        </ul>
        <p>
          Splitley reserves the right to remove content or restrict access at its discretion.
        </p>

        <h2>Privacy</h2>
        <p>
          Your use of Splitley is subject to our Privacy Policy, which explains how we collect, use, and protect your information.
        </p>
        <p>
          By using Splitley, you consent to the processing of your data as described in the Privacy Policy.
        </p>

        <h2>Service Availability and Changes</h2>
        <p>
          Splitley is provided on an "as is" and "as available" basis.
        </p>
        <p>
          We do not guarantee uninterrupted or error-free operation. Features may change, be limited, or be discontinued at any time without notice.
        </p>

        <h2>Termination</h2>
        <p>
          You may stop using Splitley at any time.
        </p>
        <p>We may suspend or terminate your access if:</p>
        <ul>
          <li>You violate these Terms</li>
          <li>You misuse the service</li>
          <li>We are required to do so by law</li>
        </ul>
        <p>
          Termination may result in loss of access to your account and content.
        </p>

        <h2>Limitation of Liability</h2>
        <p>To the maximum extent permitted by law:</p>
        <ul>
          <li>Splitley is not liable for indirect, incidental, consequential, or special damages</li>
          <li>Splitley is not responsible for financial losses, disputes, or disagreements between users</li>
          <li>Use of the service is at your own risk</li>
        </ul>

        <h2>Modifications to These Terms</h2>
        <p>
          We may update these Terms from time to time. Changes become effective when posted.
        </p>
        <p>
          Continued use of Splitley after changes means you accept the updated Terms.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions about these Terms, please contact us at:
        </p>
        <p>
          Email: <a href="mailto:support@splitley.com">support@splitley.com</a>
        </p>
      </div>
    </div>
  );
}
